import { EstablishmentMarker } from '@/modules/accredited-establishments/api'
import { EstablishmentGeoJsonFeatureProperties } from '@/modules/accredited-establishments/components/Maps/Supercluster'
import { Point, Feature, FeatureCollection } from 'geojson'
import { WIconComponentProps } from '@alice-health/wonderland/loader'

const toFeature = (
  marker: EstablishmentMarker
): Feature<Point, EstablishmentGeoJsonFeatureProperties> => {
  return {
    type: 'Feature',
    id: marker.referencedId,
    geometry: {
      type: 'Point',
      coordinates: [Number(marker.lon), Number(marker.lat)]
    },
    properties: {
      category: marker.category,
      icon: marker.icon as WIconComponentProps['icon']
    }
  }
}

const toFeatureCollection = (
  markers: EstablishmentMarker[]
): FeatureCollection<Point, EstablishmentGeoJsonFeatureProperties> => {
  const collection = markers.map(marker => {
    return toFeature(marker)
  })

  return { type: 'FeatureCollection', features: collection }
}

export { toFeatureCollection }
